// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TCrOM","footer":"styles_footer__2BqfJ"};